export default __webpack_public_path__ + "static/media/ht-immune.d135a49b.png";